// Import all modules
import { initializeNavigation } from "./nav/nav";
import { fillCalendar } from "./calendar/calendar";
import {
  fillNextChallenge,
  fillNextMeeting,
  fillNextTurnersTalk,
  fillUpcomingChallenges,
  fillUpcomingMeetingEvents,
  fillUpcomingTurnersTalks,
} from "./events/events";
import {
  fillAnnouncements,
  initializeAnnouncements,
} from "./announcements/announcements";
import { initializeCarousels } from "./carousel/carousel";
import { updateGalleryList, updateGallerySlides } from "./galleries/galleries";
import { populateGallerySection } from "./galleries/slideshow";
import {
  fillNewsletterArchive,
  fillNextNewsletterDeadline,
  updateLatestNewsletterHref,
} from "./newsletters/newsletter";
import { fillOfficerEmails } from "./officers/officers";
import { fillToolsList } from "./tools/tools";
import { populateYouTubeVideos } from "./video";
import { validateExternalLinks } from "./util/link-validation";

// Initialize core functionality
initializeNavigation();
initializeAnnouncements();
validateExternalLinks();

window.addEventListener("load", (event) => {
  fillAnnouncements("#announcements-page-list");

  fillCalendar("#event-list");

  fillNextChallenge(".highlights .next-challenge");
  fillNextMeeting(".highlights .next-meeting");
  fillNextTurnersTalk(".highlights .turners-talk");
  fillUpcomingChallenges("challenges-list");
  fillUpcomingMeetingEvents("upcoming-events-list");
  fillUpcomingTurnersTalks("turners-talks-list");

  populateGallerySection();
  updateGalleryList("#gallery-list");

  fillNewsletterArchive(".newsletter-archives");
  fillNextNewsletterDeadline(".newsletter-deadline");
  updateLatestNewsletterHref(".latest-newsletter-link");

  fillOfficerEmails();

  fillToolsList("tools-list");

  populateYouTubeVideos(".video-section", 500);

  initializeCarousels();
});
